import { useState } from 'react';
import NavButtons from '../components/NavButtons';
import ContentBlocks from '../components/ContentBlocks';

function PuzzleScreen({ heading, question, correctAnswer, blocks, onBack, onNext, showBack = true }) {
  const [input, setInput] = useState('');

  const normalize = (s) => s.toLowerCase().replace(/[\s.,!?'"]+/g, '');
  const answers = Array.isArray(correctAnswer) ? correctAnswer : [correctAnswer];
  const isCorrect = answers.some((a) => normalize(input) === normalize(a));

  return (
    <div className="screen">
      <div className="screen-content">
          <h1 className="screen-title">{heading}</h1>
          <ContentBlocks blocks={blocks} />
        <p className="puzzle-question">{question}</p>
        <input
          type="text"
          className="form-input"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Your answer..."
          autoComplete="off"
        />
      </div>
      <NavButtons onBack={onBack} onNext={onNext} showBack={showBack} nextDisabled={!isCorrect} />
    </div>
  );
}

export default PuzzleScreen;